import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import { StoreProvider } from "./context/StoreContext";
import { AuctionProvider } from "./context/AuctionContext";
import { WalletProvider } from "./context/WalletContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { ChatProvider } from "./context/ChatContext";
import { useLocation } from "react-router-dom";
import { useChat } from "./context/ChatContext";
import { GlobalSearchProvider } from "./context/GlobalSearchContext";
import { PodcastProvider } from "./context/PodcastContext";
import { SettingsProvider } from "./context/SettingsContext";
import { TournamentProvider } from "./context/TournamentContext";
import { SearchProvider } from "./context/SearchContext";
import { VoiceChatProvider } from "./context/VoiceChatContext";
import { NotificationProvider } from "./context/NotificationContext";
import { PlanProvider } from "./context/PlanTypeContext";
import { AddDreamDescProvider } from "./context/AddDreamContext";
import { ForumsProvider } from "./context/ForumsContext";
import { KYCProvider } from "./context/KycContext";
import { Suspense, useEffect, useState } from "react";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

import SignupForm from "./pages/Auth/signup";
import SigninForm from "./pages/Auth/signin";
import Forgetpassword from "./pages/Auth/forgetpassword";
import OtpVerification from "./pages/Auth/otp";
import ResetPassword from "./pages/Auth/resetpassword";
import HomePage from "./pages/Homepage/Index";
import CurrentTunament from "./pages/CurrentTunament/index";
import Allgames from "./pages/CurrentTunament/Allgames";
import SelectGame from "./pages/CurrentTunament/Selectgame";
import SelectedGamesTournaments from "./pages/CurrentTunament/selectedgamestournaments";
import CreateTournaments from "./pages/CurrentTunament/Createtournements";
import TournamentsDetails from "./pages/CurrentTunament/Tournamentdetails";
import BracketsProgress from "./pages/CurrentTunament/bracketsandprocess";
import ForumnsIndex from "./pages/Forumns";
import StorePage from "./pages/Stores/Index";
import StoreCategory from "./pages/Stores/StoreCategory";
import ProductDetails from "./pages/Stores/ProductDetail";
import CheckOutIndex from "./pages/Checkout-page/Index";
import ForumDetailPage from "./pages/Forumns/forumdetailpage";
import FinalRoundNews from "./pages/Forumns/finalroundnews";
import PodcastsIndex from "./pages/podcasts";
import PodcastsListIndex from "./pages/podcasts/poadcastlist";
import PoadcastveiewPage from "./pages/podcasts/poadcastviewpage";
import LivestreamIndex from "./pages/livestream";
import SendGiftIndex from "./pages/livestream/sendgift";
import WalletPage from "./pages/walllet";
import BuyToken from "./pages/walllet/buytoken";
import AuctionsPage from "./pages/Auctions/Index";
import CreateAuction from "./pages/Auctions/CreateAuction";
import AuctionDetail from "./pages/Auctions/AuctionDetail";
import MyBidsIndex from "./pages/MyBids/Index";
import BidsDetail from "./pages/MyBids/BidsDetail";
import ChatInterface from "./pages/Chats/Index";
import ConnectionIndex from "./pages/Connections/Index";
import ConnectionProfileSec from "./pages/Connections/ConnectionsProfile";
import ProfileIndex from "./pages/Profile/Index";
import EditProfileIndex from "./pages/Profile/EditProfile";
import SendTokens from "./pages/walllet/sendtoken";
import WithdrawToken from "./pages/walllet/withdrawtoken";
import OrderIndex from "./pages/Orders/Index";
import OrderIdDetailsPage from "./pages/Orders/OrderIdDetail";
import NotificationsIndex from "./pages/Notifications/Index";
import DeliveryAddresses from "./pages/Addresses/Index";
import LeaderboardIndex from "./pages/Leaderboard/Index";
import AboutLeaderboard from "./pages/Leaderboard/AboutLeaderboard";
import ActiveDevicesIndex from "./pages/Devices/Index";
import HelpCenterIndex from "./pages/HelpCenter/Index";
import FeedbackIndex from "./pages/FeedbackSubmit/Index";
import PlatformPolicies from "./pages/PlatformPolicies/Index";
import UpcomingTournament from "./pages/UpcomingTournament/Index";
import LiveTournament from "./pages/LiveTournaments/Index";
import LobbyTournament from "./pages/Tournaments Lobby/Index";
import GamesIndex from "./pages/Games/Index";
import SelectedGameDetail from "./pages/Games/SelectedGameDetail";
import CreatePrivateTournament from "./pages/Games/CreatePrivateTournament";
import PastTournament from "./pages/PastTournaments/Index";
import KYCIndex from "./pages/Profile/Kyc";
import SubscriptionsIndex from "./pages/Subscriptions/Index";
import TournamentResult from "./pages/TournamentResult";
import GuidelineTutorials from "./pages/GuidelineTutorials";
import FaqAndTerms from "./pages/FAQ&Terms";
import SuggestionsPage from "./pages/Suggestions";
import CompliancePage from "./pages/Compliance";
import ContactPage from "./pages/Contact";
import PrivateTournaments from "./pages/PrivateTournaments/PrivateTournaments";
import Settings from "./pages/Settings";
import { useAuth } from "./context/AuthContext";

import TermsAndCodition from "./pages/Termsandcondition";
import PrivecyPolicy from "./pages/PrivecyPolicy";
import CreateBrackets from "./pages/PrivateTournaments/CreateBrackets";
import Brackets from "./pages/PrivateTournaments/Brackets";
import {
  getMessagingSafe,
  onMessage,
  requestFcmToken,
} from "./config/firebase";
import { LeaderboardProvider } from "./context/LeaderboardContext";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  // const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  // const userId = userProfile ? userProfile._id : "";

  const [userId, setUserId] = useState("");

  useEffect(() => {
    const profile = JSON.parse(localStorage.getItem("userProfile"));
    setUserId(profile?._id || "");
  }, []);

  // uncomment on production https -------- Push Notification
  useEffect(() => {
    let messaging = getMessagingSafe();
    const init = async () => {
      const token = await requestFcmToken();
    };

    init();

    if (messaging) {
      onMessage(messaging, (payload) => {
        // Show native web push notification
        if (Notification.permission === "granted") {
          const clickActionRaw = payload?.data?.click_action || "";
          const userId =
            payload?.data?.userId || payload?.data?.followerId || "";
          const section = clickActionRaw.toLowerCase();
          const path = `/${section}/${userId}`;

          const notification = new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: "/logo.png", // optional
          });

          // --------- Redirect when click on the notification ----------
          notification.onclick = () => {
            window.focus();
            window.location.href = path;
          };
        }
      });
    }
  }, []);

  useEffect(() => {
    const updateUser = () => {
      const profile = JSON.parse(localStorage.getItem("userProfile"));
      setUserId(profile?._id || "");
    };

    window.addEventListener("storage", updateUser);
    window.addEventListener("user-updated", updateUser);

    return () => {
      window.removeEventListener("storage", updateUser);
      window.removeEventListener("user-updated", updateUser);
    };
  }, []);

  // App Context Wrapper: Provides all global states (Auth, Chat, Wallet, Tournaments, Notifications, Settings, etc.)
  return (
    <BrowserRouter>
      <AuthProvider>
        <GlobalSearchProvider>
          <LeaderboardProvider>
            <AppContextProvider>
              <SettingsProvider>
                <SubscriptionProvider>
                  <StoreProvider>
                    <AuctionProvider>
                      <WalletProvider>
                        <SearchProvider>
                          <ForumsProvider>
                            <PodcastProvider>
                              <TournamentProvider>
                                <NotificationProvider>
                                  <ChatProvider
                                    key={userId}
                                    currentUserId={userId}
                                  >
                                    <VoiceChatProvider>
                                      <KYCProvider>
                                        <AddDreamDescProvider>
                                          <PlanProvider>
                                            <Suspense fallback={<Loader />}>
                                              <ScrollToTop />
                                              <ToastContainer
                                                closeOnClick={false}
                                              />
                                              <AppRoutes />
                                            </Suspense>
                                          </PlanProvider>
                                        </AddDreamDescProvider>
                                      </KYCProvider>
                                    </VoiceChatProvider>
                                  </ChatProvider>
                                </NotificationProvider>
                              </TournamentProvider>
                            </PodcastProvider>
                          </ForumsProvider>
                        </SearchProvider>
                      </WalletProvider>
                    </AuctionProvider>
                  </StoreProvider>
                </SubscriptionProvider>
              </SettingsProvider>
            </AppContextProvider>
          </LeaderboardProvider>
        </GlobalSearchProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

// --------- APP Rounting ---------
const AppRoutes = () => {
  const location = useLocation();
  const { setGlobalOnlineStatus } = useChat();
  useEffect(() => {
    if (location.pathname === "/chat") {
      setGlobalOnlineStatus(true);
    } else {
      setGlobalOnlineStatus(false);
    }
  }, [location.pathname]);
  return (
    <Routes>
      <Route path="/" element={<SignupForm />} />
      <Route path="/sign-up" element={<SignupForm />} />
      <Route path="/sign-in" element={<SigninForm />} />
      <Route path="/forget-password" element={<Forgetpassword />} />
      <Route path="/otp" element={<OtpVerification />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privecy-policy" element={<PrivecyPolicy />} />
      <Route path="/terms-and-condition" element={<TermsAndCodition />} />

      {/* <Route path="/" element={<HomePage />} /> */}
      <Route path="/home" element={<HomePage />} />
      <Route path="/current-tournaments" element={<CurrentTunament />} />
      <Route path="/upcoming-tournaments" element={<UpcomingTournament />} />
      <Route path="/past-tournaments" element={<PastTournament />} />
      <Route path="/live-tournaments" element={<LiveTournament />} />
      <Route path="/private-tournaments" element={<PrivateTournaments />} />
      <Route
        path="/private-tournaments/create-bracket/:id"
        element={<CreateBrackets />}
      />
      <Route path="/private-tournaments/brackets/:id" element={<Brackets />} />
      <Route path="/lobby-tournaments/:id" element={<LobbyTournament />} />
      <Route path="/:tournament/games" element={<GamesIndex />} />
      <Route
        path="/:tournament/games/:selected-games"
        element={<SelectedGameDetail />}
        // element={<SelectedGamesIndex />}
      />
      <Route path="/selected-games-detail" element={<SelectedGameDetail />} />
      <Route
        path="/create-private-tournament"
        element={<CreatePrivateTournament />}
      />
      <Route path="/:tournament/all-games" element={<Allgames />} />
      <Route path="/select-game" element={<SelectGame />} />
      <Route
        path="/selectedgames-tournaments"
        element={<SelectedGamesTournaments />}
      />
      <Route path="/create-tournaments" element={<CreateTournaments />} />

      <Route
        path="/:tournament/tournaments-details/:id"
        element={<TournamentsDetails />}
      />
      <Route path="/brackets-progress" element={<BracketsProgress />} />
      <Route path="/forums" element={<ForumnsIndex />} />
      <Route path="/stores" element={<StorePage />} />
      <Route path="/forums/:id" element={<ForumDetailPage />} />
      <Route path="/:forums/finalroundnews/:id" element={<FinalRoundNews />} />
      <Route path="/podcasts" element={<PodcastsIndex />} />
      <Route path="/podcasts/:year" element={<PodcastsListIndex />} />
      <Route path="/podcasts/:year/:id" element={<PoadcastveiewPage />} />
      <Route path="/live-stream" element={<LivestreamIndex />} />
      <Route path="/:stream/send-gift/:id" element={<SendGiftIndex />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/wallet/buy-token" element={<BuyToken />} />
      <Route path="/wallet/send-token" element={<SendTokens />} />
      <Route path="/wallet/withdraw-token" element={<WithdrawToken />} />
      {/* <Route
        path="/:tournament/tournament-result"
        element={<TournamentResult />}
      /> */}

      <Route path="/:tournament/tournament-result/:id" element={<Brackets />} />

      <Route path="/stores/:id" element={<StoreCategory />} />
      <Route path="/:store/product/:storeId/:id" element={<ProductDetails />} />
      <Route path="/checkout" element={<CheckOutIndex />} />
      <Route path="/auctions" element={<AuctionsPage />} />
      <Route path="/auctions-create" element={<CreateAuction />} />
      <Route path="/:auction/auctions-detail/:id" element={<AuctionDetail />} />
      <Route path="/my-bids" element={<MyBidsIndex />} />
      {/* <Route path="/bids-detail/:id" element={<BidsDetail />} /> */}
      <Route path="/bids/bid-detail/:id" element={<BidsDetail />} />
      <Route path="/chat" element={<ChatInterface />} />
      <Route path="/connections" element={<ConnectionIndex />} />
      <Route path="/profile/:id" element={<ConnectionProfileSec />} />
      <Route path="/profile" element={<ProfileIndex />} />
      <Route path="/kyc" element={<KYCIndex />} />
      <Route path="/edit-profile" element={<EditProfileIndex />} />
      <Route path="/order" element={<OrderIndex />} />
      <Route path="/your-order-detail/:id" element={<OrderIdDetailsPage />} />
      <Route path="/notifications" element={<NotificationsIndex />} />
      <Route path="/address" element={<DeliveryAddresses />} />
      <Route path="/subscriptions" element={<SubscriptionsIndex />} />
      <Route path="/leaderboard" element={<LeaderboardIndex />} />
      <Route path="/about-leaderboard" element={<AboutLeaderboard />} />
      <Route path="/active-devices" element={<ActiveDevicesIndex />} />
      <Route path="/help-center" element={<HelpCenterIndex />} />
      <Route path="/feadback" element={<FeedbackIndex />} />
      <Route path="/platform-policies" element={<PlatformPolicies />} />
      <Route path="/guideline-tutorials" element={<GuidelineTutorials />} />
      <Route path="/faqandterms" element={<FaqAndTerms />} />
      <Route path="/suggestion" element={<SuggestionsPage />} />
      <Route path="/compliance" element={<CompliancePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/settings" element={<Settings />} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
